import React from 'react'
import { connect } from 'react-redux'

import { TextField } from '@material-ui/core'
import IconClear from './IconClear'

import setSearchString from './actions'
import setAccountIdParam from '../AccountSelector/actions'

import './index.scss'

class UserSearch extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            searchValue: '',
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.clearSearchString = this.clearSearchString.bind(this)
    }

    handleChange(evt) {
        const { value: searchValue } = evt.target
        this.setState({ searchValue })
    }

    handleKeyDown = e => {
        if (e.key !== 'Enter') {
            return
        }

        const { searchValue } = this.state

        this.props.setSearchString(searchValue)
    }

    clearSearchString() {
        const searchValue = ''

        this.setState({ searchValue })
        this.props.setSearchString(searchValue)
        this.props.setAccountIdParam('')
    }

    render() {
        const { searchValue } = this.state

        return (
            <div className='UserSearch'>
                <span>Email/Phone</span>
                <TextField
                    placeholder='example@mail.com'
                    onChange={this.handleChange}
                    onKeyDown={this.handleKeyDown}
                    value={searchValue}
                />
                {searchValue && (
                    <span onClick={this.clearSearchString}>
                        <IconClear />
                    </span>
                )}
            </div>
        )
    }
}

export default connect(null, { setSearchString, setAccountIdParam })(UserSearch)
